export default __webpack_public_path__ + "static/media/user.ddc332da.png";